import * as React from "react";
import { Flex, Heading, Spacer } from "@chakra-ui/react";
import BackButton from "../back-button";
import Tabs from "../tabs";
import Wrapper from "../wrapper";

interface PageHeaderProps {
  title: string;
  backURL?: string | number;
  actions?: React.ReactNode;
  tabs?: Record<string, { id: number; to: string; name: string }>;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  actions,
  backURL,
  tabs
}) => {
  return (
    <Wrapper>
      <Flex direction="column" rowGap={8}>
        <Flex alignItems="center">
          <Flex alignItems="center" columnGap={4}>
            {backURL && <BackButton backURL={backURL} />}

            <Heading
              fontSize="2xl"
              lineHeight={8}
              fontWeight="semibold"
              color="gray.700"
            >
              {title}
            </Heading>
          </Flex>

          {actions && <Spacer />}
          {actions}
        </Flex>
        {tabs && (
          <Tabs tabs={tabs} tabProps={{ px: { base: "12px", lg: "16px" } }} />
        )}
      </Flex>
    </Wrapper>
  );
};

export default PageHeader;
